/**
 * @module isObjectLiteral
 * @since 2.8.0
 */

/**
 * Validates a given value is a literal Object.
 *
 * @param {*} value The value to validate.
 * @return {Boolean}
 */
export const isObjectLiteral = (value) => value == '[object Object]'; // eslint-disable-line eqeqeq
